import { BasicErrorService } from './BasicErrorService';
import { BasicCampaignTrackingService } from './BasicCampaignTrackingService';

export class MglErrorService<T extends BasicAppDefinition> extends BasicErrorService<T> {
	protected readonly trackingService: BasicCampaignTrackingService<T>;

	constructor(options: BasicAppOptions<T>) {
		super(options);
		this.trackingService = new BasicCampaignTrackingService(options);
	}

	/**
	 * Overwrites the renderTemplate method to add the campaign tracking for membership applications.
	 */
	protected renderTemplate(template: string, config: { [key: string]: any }): void {
		super.renderTemplate(this.trackingService.setTracking(template), config);
	}
}
